import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { cloneElement } from 'react';
import { InverseButton, PrimaryButton, TextLink } from "../../../Buttons";
import { parseClassnames } from "../../../helpers";
import { jsx as _jsx } from "react/jsx-runtime";
var Action = function Action(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'm' : _ref$type,
    action = _ref.action,
    actionType = _ref.actionType,
    isDark = _ref.isDark,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  if (action && !('label' in action)) {
    return /*#__PURE__*/cloneElement(action, {
      // apply only tailwind classNames that are not provided
      className: parseClassnames(action.props.className || '', className)
    });
  }
  if (action && action.label) {
    var btnProps = _objectSpread({
      className: className
    }, action);
    if (actionType === '1' || actionType === 'confirm') {
      return (
        /*#__PURE__*/
        // @ts-ignore
        _jsx(PrimaryButton, _objectSpread(_objectSpread({
          size: "l",
          full: type !== 'full' || actionType === 'confirm',
          isDark: isDark
        }, btnProps), {}, {
          className: type !== 'm-form' ? parseClassnames(btnProps.className, 'max-w-280') : btnProps.className
        }))
      );
    }
    if (actionType === '2' || actionType === 'cancel') {
      return (
        /*#__PURE__*/
        // @ts-ignore
        _jsx(InverseButton, _objectSpread(_objectSpread({
          size: "l",
          gray: actionType === 'cancel',
          full: type !== 'full' || actionType === 'cancel',
          isDark: isDark
        }, btnProps), {}, {
          className: type !== 'm-form' || actionType === 'cancel' ? parseClassnames(btnProps.className, 'max-w-280') : btnProps.className
        }))
      );
    }
    // @ts-ignore
    return /*#__PURE__*/_jsx(TextLink, _objectSpread(_objectSpread({}, btnProps), {}, {
      type: "level2"
    }));
  }
  return null;
};
export default Action;